import type { Content } from '#types/content'
import type { ModulesConfig } from '#types/mappings'

export const resolveContentComponent = (content: Content, mappings: ModulesConfig) => {
  const config = mappings[content?.type]

  if (!config)
    return

  let { hydration, hydrationOptions, component, variants } = config

  if (content.type === 'P13NExperience') {
    const variant = content.experienceId?.includes('monetate_experience') ? variants.experience : variants.experiment
    component = variant.component
    hydration = variant.hydration
    hydration = variant.hydration || hydration
  }
  else if (variants) {
    const variant = variants[content.variant!] || variants.default
    component = variant.component
    hydration = variant.hydration || hydration
    hydrationOptions = variant.hydrationOptions || hydrationOptions
  }

  return { ...content, componentType: component, hydration, hydrationOptions }
}
